<div class="title">{{showTitle ? item.title : ''}}</div>
<div class="line-container">
  <div class="left-circle"></div>
  <div class="line"></div>
  <div class="right-circle"></div>
</div>
